var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.993,
    height: 12.34,
    viewBox: "0 0 18.993 12.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18462",
    "data-name": "Path 18462",
    d: "M18.7,8.185H15.432V5.306H18.1a.3.3,0,0,0,.3-.3V1.484A1.486,1.486,0,0,0,16.916,0H2.077A1.486,1.486,0,0,0,.594,1.484V5.01a.3.3,0,0,0,.3.3H3.561V8.185H.3a.3.3,0,0,0,0,.594H1.781v3.264a.3.3,0,0,0,.594,0V8.779H16.619v3.264a.3.3,0,1,0,.594,0V8.779H18.7a.3.3,0,0,0,0-.594m-.89-5.1H1.187v-.95H17.806ZM1.264,1.138A.878.878,0,0,1,2.077.6H16.916a.881.881,0,0,1,.807.535l.18.414H1.092ZM1.187,3.674H17.806v.95H1.187ZM14.839,8.185H4.155V5.306H14.839Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/Bench.611f2359.svg";
export { ForwardRef as ReactComponent };